export const title = function(text: string) {
  return text.split(/\n/)[0]
    ? text.split(/\n/)[0].replace(/#\s/, "")
    : "無題のメモ";
};

export const previewContent = function(text: string) {
  const returnText = text
    .replace(/^[\s]*\n/g, "") //空の行を抜く
    .split(/\n/)
    .filter(t => t);

  returnText.shift();
  returnText.push("");
  returnText.push("");
  return returnText;
};
